const state = {
  debits : [],
  errors: null
}

export default state